import { Route, Routes } from 'react-router-dom';
import Ramme from './components/Ramme';
import IkkeFunnet from './pages/IkkeFunnet';
import KundeReise from './pages/KundeReise';
import Konsoll from './pages/Konsoll';

/** Rutene. Ruteren (BrowserRouter) ligger i index.tsx, så testene kan bruke MemoryRouter. */
export default function App() {
  return (
    <Ramme>
      <Routes>
        <Route path="/r/:lenke" element={<KundeReise />} />
        <Route path="/konsoll/*" element={<Konsoll />} />
        <Route path="*" element={<IkkeFunnet />} />
      </Routes>
    </Ramme>
  );
}
